<template>
  <div class="">
    <page-header title="New Route" breadcrumb="Dashboard >> Settings >> Routes >> New Route" />
    <div class="mt-3 custom-card">
      <create-route-form :states="states" />
    </div>
  </div>
</template>

<script>
import CreateRouteForm from "./partials/CreateRouteForm.vue";

export default {
  components: {
    CreateRouteForm,
  },
  data() {
    return {
      routeType: "intraState",
    };
  },
  mounted() {
    this.getAllStatesAndCities();
  },
  methods: {

    createRequestPayload() { },
  },
  computed: {
    isInterstate() {
      return this.routeType === "interState";
    },
    isIntrastate() {
      return this.routeType === "intraState";
    },
    international() {
      return this.routeType === "international";
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.route-type {
  display: flex;
  flex-wrap: wrap;

  p {
    padding-right: 2rem;
  }
}

.route-type-options {
  display: flex;
  flex-wrap: wrap;

  .single-option {
    padding-right: 1.5rem;
  }
}
</style>
